import type { ReactNode } from 'react';

export const symbol_edit_square: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h333q15 0 22.5 9.32t7.5 20.5q0 11.18-7.68 20.68-7.69 9.5-22.32 9.5H180v600h600v-336q0-15 9.32-22.5t20.5-7.5q11.18 0 20.68 7.5T840-516v336q0 24-18 42t-42 18H180Zm300-360Zm-120 90v-115q0-12.44 5-23.72T378-548l364-364q9-9 20-13t22-4q11 0 22.32 4.5Q817.63-920 827-911l83 84q8.61 8.96 13.3 19.78 4.7 10.83 4.7 22.02 0 11.2-4.5 22.7T910-742L548-378q-8 8-19.28 13-11.28 5-23.72 5H390q-12.75 0-21.37-8.63Q360-377.25 360-390Zm508-395-84-84 84 84ZM420-420h85l253-253-43-42-43-42-252 251v86Zm295-295-43-42 43 42 43 42-43-42Z"
		/>
	</svg>
);
